import { orgServiceApiSlice } from "state/services/orgServiceApiSlice";

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Enterprise-wide Copilot usage endpoints — no org_id/cost_center_id scoping,
// aggregated across every organization. Separate module from copilotQueries.js
// since every endpoint there requires an org or cost-center scope; these two
// deliberately never take one.
const enterpriseCopilotApiQueries = orgServiceApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET /api/organizations/enterprise/copilot-usage?platform_id=&start_date=&end_date=
    // Returns an enterprise-wide summary (same summary shape as the per-org
    // dashboard) plus an org_breakdown[] — one row per org with its own
    // totals and usage_stats, pre-sorted desc by total_gross_credits.
    getEnterpriseCopilotUsage: builder.query({
      query: ({ platformId, startDate, endDate }) => ({
        url: `/organizations/enterprise/copilot-usage?platform_id=${encodeURIComponent(platformId)}&start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`,
      }),
    }),

    // GET /api/organizations/enterprise/copilot-usage/monthly?platform_id=
    // Rolling monthly trend, enterprise-wide, plus a per-org monthly
    // breakdown for the togglable per-org overlay lines.
    getEnterpriseCopilotUsageMonthly: builder.query({
      query: ({ platformId }) => ({
        url: `/organizations/enterprise/copilot-usage/monthly?platform_id=${encodeURIComponent(platformId)}`,
      }),
      transformResponse: (responseData) => {
        const withLabel = (item) => ({ ...item, label: `${MONTH_NAMES[item.month - 1]} ${item.year}` });
        return {
          monthly: (responseData.monthly ?? []).map(withLabel),
          orgBreakdown: (responseData.org_breakdown ?? []).map((org) => ({
            ...org,
            monthly: (org.monthly ?? []).map(withLabel),
          })),
        };
      },
    }),
  }),
});

export const {
  useGetEnterpriseCopilotUsageQuery,
  useGetEnterpriseCopilotUsageMonthlyQuery,
} = enterpriseCopilotApiQueries;
